import React from 'react'

import { SimpleInput } from '@makyoapp/makyo-ui'

import { SpacingInputUnit } from '@/shared/builder'

export function SpaceFieldWithUnit<Pos>({
  id,
  icon,
  value,
  position,
  onChange,
  max,
}: {
  id: string
  icon: React.ReactNode
  value: {
    value: number
    unit: SpacingInputUnit
  }
  position?: Pos
  onChange: (value: number, unit: SpacingInputUnit, position?: Pos) => void
  max?: {
    [SpacingInputUnit.Pixel]: number
    [SpacingInputUnit.Rem]: number
    [SpacingInputUnit.Em]: number
    [SpacingInputUnit.Percent]: number
  }
}) {
  return (
    <div className='spi-wrap'>
      <SimpleInput
        before={<div className='spi-icon'>{icon}</div>}
        id={id}
        className='spi-si'
        pattern='-?[0-9]*'
        inputClassName='spi-input'
        value={value?.value}
        onChange={(e) => {
          const val = e.currentTarget.value

          if (val === '-') {
            onChange(val as any, value?.unit, position)
            return
          }

          const numVal = Number(val)
          const maxVal = max?.[value?.unit]

          if (isNaN(numVal)) {
            onChange(value?.value, value?.unit, position)
            return
          }

          onChange(isNaN(numVal) ? 0 : maxVal && maxVal < numVal ? maxVal : numVal, value?.unit, position)
        }}
        after={
          <select
            value={value?.unit}
            className='bg-transparent'
            onChange={(e) => {
              const nextUnit = e.currentTarget.value as SpacingInputUnit
              let newValue = value?.value
              const maxVal = max?.[nextUnit]
              if (maxVal && maxVal < newValue) {
                newValue = maxVal
              }
              onChange(newValue, nextUnit, position)
            }}
          >
            {Object.values(SpacingInputUnit).map((v) => {
              return (
                <option key={v} value={v}>
                  {v}
                </option>
              )
            })}
          </select>
        }
      />
    </div>
  )
}
